import styled, { css, keyframes } from 'styled-components';
import Spinner from '../../assets/images/downloading-spinner.svg';

const animation = keyframes`
    0% {
        transform: scale(1) rotate(0deg);
    }
    100% {
        transform: scale(1) rotate(360deg);
    }
`;
const animationRule = css`
  ${animation} 2s infinite linear;
`;

interface LoadingSpinnerIconProps {
  light?: boolean;
}

const LoadingSpinnerIcon = styled.span<LoadingSpinnerIconProps>`
  height: 17px;
  position: relative;
  width: 17px;

  &:after {
    animation: ${animationRule};
    content: '';
    display: block;
    margin: -50% 0 0 -50%;
    width: 34px;
    height: 34px;

    ${({ light }) => `
      background-color: ${light ? '#fff' : '#949999'};
      mask-image: url("${Spinner}");
      mask-position: center center;
      mask-repeat: no-repeat;
      mask-size: 80%;
    `}
  }
`;

export default LoadingSpinnerIcon;
